import React from 'react'
import styles from './styles.css'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import cloneDeep from 'lodash/cloneDeep'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc'
import gql from 'graphql-tag'
import each from 'lodash/each'

const SortableItem = SortableElement(({item}) => <div>{item}</div>)

const SortableList = SortableContainer(({items, draggable}) => {
  return (
    <div>
      {items.map((item, index) => (
        <SortableItem disabled={!draggable} key={`item-${index}`} index={index} item={item} />
      ))}
    </div>
  )
})

@withGraphQL(gql`
  query getMe {
    me {
      _id
      email
      profile {
        name
      }
    }
  }
`)
// TODO: Separar componentes cuando vienen de los roles plz
export default class Signers extends React.Component {
  static propTypes = {
    value: PropTypes.array,
    signersRoles: PropTypes.array,
    onChange: PropTypes.func,
    addMe: PropTypes.bool,
    me: PropTypes.func,
    autoAdd: PropTypes.bool,
    draggable: PropTypes.bool
  }

  static defaultProps = {
    autoAdd: true
  }

  componentDidMount() {
    const items = cloneDeep(this.props.value || [])
    each(this.props.signersRoles, signerRole => {
      items.push({role: signerRole.name})
      this.props.onChange(items)
    })
  }

  @autobind
  add() {
    const items = cloneDeep(this.props.value || [])
    items.push({})
    this.props.onChange(items)
  }

  addRoles() {
    const items = cloneDeep(this.props.signersRoles || [])
    items.push({})
    this.props.onChange(items)
  }

  onChange(value, field, index) {
    const items = cloneDeep(this.props.value || [])
    if (typeof items[index] === 'undefined') {
      items.push({})
      items[index][field] = value
      this.props.onChange(items)
    } else {
      items[index][field] = value
      this.props.onChange(items)
    }
  }

  delete(index) {
    const items = cloneDeep(this.props.value || [])
    items.splice(index, 1)
    this.props.onChange(items)
  }

  renderSignersTemplates() {
    const value = this.props.value || []
    const signers = this.props.signersRoles.map((signer, index) => {
      const onChange = field => value => this.onChange(value, field, index)
      return (
        <div key={index} className="row">
          <div className="col-xs-12 col-sm-2">{signer.name}</div>
          <div className="col-xs-12 col-sm-5">
            <Text
              value={value[index] ? value[index].name : ''}
              onChange={onChange('name')}
              placeholder="Nombre"
            />
          </div>
          <div className="col-xs-12 col-sm-5">
            <Text
              value={value[index] ? value[index].email : ''}
              onChange={onChange('email')}
              placeholder="Email"
              fieldType="email"
            />
          </div>
        </div>
      )
    })
    const onSortEnd = ({oldIndex, newIndex}) =>
      this.props.onChange(arrayMove(value, oldIndex, newIndex))
    return (
      <SortableList
        distance={2}
        items={signers}
        draggable={this.props.draggable}
        onSortEnd={onSortEnd}
      />
    )
  }

  render() {
    return <div className={styles.container}>{this.renderSignersTemplates()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/SignersByRoles/index.js